import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoriesSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-display-sm md:text-display-md text-foreground-900 mb-4">
            内容分类
          </h2>
          <p className="text-foreground-500 text-base max-w-2xl mx-auto">
            覆盖赛事资讯、数据分析、使用教程等多个领域，总有你感兴趣的内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer flex items-start gap-4"
            >
              <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-500 transition-colors duration-300">
                <i className={`${category.icon} text-lg text-accent-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-base font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                  {category.name}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {category.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}